<template>
  <div>
    <div class="app-interfaces-events-chart-wrapper__header" v-if="orgData">
      <span class="app-interfaces-events-chart-wrapper__title"
        >Apps and interface events</span
      >
      <v-spacer />
      <div class="d-flex">
        <v-spacer />
        <v-select
          dense
          outlined
          v-if="orgData.apps && on"
          v-model="selectedApp"
          :class="{ 'mr-4': on }"
          :items="orgData.apps"
          class="app-interfaces-events-chart-wrapper__app-select"
          placeholder="Select app"
          hide-details="auto"
          item-text="name"
          item-value="id"
          @input="chooseApp"
        >
        </v-select>
        <apio-pill-switch
          :on="on"
          class="app-interfaces-events-chart__switch"
          @toggleOff="on = false"
          @toggleOn="on = true"
        >
          <template slot="left">Condensed view</template>
          <template slot="right">Expanded view</template>
        </apio-pill-switch>
      </div>
    </div>

    <!-- Condensed -->
    <div
      v-if="on && selectedApp"
      :a="selectedApp"
      class="app-interfaces-events-chart-wrapper__charts"
    >
      <div v-if="!getInterfacesForApp.length">
        No interfaces defined for app
      </div>
      <div
        v-for="(item, index) in getInterfacesForApp"
        :key="index"
        class="app-interfaces-events-chart-wrapper__chart"
      >
        <div class="h3 mb-10">{{ item.name }}</div>
        <LineChart v-if="selectedApp" :a="selectedApp" :i="item.id" />

        <div class="d-flex mt-6">
          <div class="d-flex mr-2">
            <apio-icon
              class="mr-2"
              size="16"
              name="ui-bullet"
              lightModeColour="success"
              darkModeColour="success"
            /><span class="small">Success</span>
          </div>
          <div class="d-flex mr-2">
            <apio-icon
              class="mr-2"
              size="16"
              name="ui-bullet"
              lightModeColour="warning"
              darkModeColour="warning"
            /><span class="small">Warning</span>
          </div>
          <div class="d-flex">
            <apio-icon
              class="mr-2"
              size="16"
              name="ui-bullet"
              lightModeColour="error"
              darkModeColour="error"
            /><span class="small">Error</span>
          </div>
        </div>
      </div>
    </div>
    <!-- Expanded -->
    <div v-else class="app-interfaces-events-chart-wrapper__charts">
      <div
        class="app-interfaces-events-chart-wrapper__chart app-interfaces-events-chart-wrapper__chart--expanded"
      >
        <div class="d-flex mb-4" v-if="organisationDashboard">
          <v-spacer />
          <v-select
            dense
            outlined
            v-if="orgData.apps"
            v-model="selectedApp"
            :class="{ 'mr-4': !on }"
            :items="orgData.apps"
            class="app-interfaces-events-chart-wrapper__app-select"
            placeholder="Select app"
            hide-details="auto"
            item-text="name"
            item-value="id"
            @input="chooseApp"
          >
          </v-select>

          <v-select
            dense
            outlined
            v-if="!on"
            v-model="selectedInterface"
            :items="getInterfacesForApp"
            :disabled="selectedApp && getInterfacesForApp.length === 0"
            class="app-interfaces-events-chart-wrapper__app-select"
            :placeholder="interfacePlaceholder"
            hide-details="auto"
            item-text="name"
            item-value="id"
            @input="chooseInterface"
          >
          </v-select>
        </div>
        <LineChart
          v-if="selectedApp && selectedInterface"
          :a="selectedApp"
          :i="selectedInterface"
        />
        <div class="d-flex mt-6">
          <div class="d-flex mr-2">
            <apio-icon
              class="mr-2"
              size="16"
              name="ui-bullet"
              lightModeColour="success"
              darkModeColour="success"
            /><span class="small">Success</span>
          </div>
          <div class="d-flex mr-2">
            <apio-icon
              class="mr-2"
              size="16"
              name="ui-bullet"
              lightModeColour="warning"
              darkModeColour="warning"
            /><span class="small">Warning</span>
          </div>
          <div class="d-flex">
            <apio-icon
              class="mr-2"
              size="16"
              name="ui-bullet"
              lightModeColour="error"
              darkModeColour="error"
            /><span class="small">Error</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "AppInterfacesEventsChartWrapper",
  components: {
    ApioPillSwitch: () => import("@/components/Misc/PillSwitch.vue"),
    LineChart: () => import("@/components/LineChart"),
  },
  props: {
    mode: {
      type: String,
      default: "condensed",
    },
    a: {
      type: String,
    },
    orgData: {
      type: Object,
    },
  },
  watch: {
    a(appId) {
      this.chooseApp(appId);
    }
  },
  data() {
    return {
      interfaceID: null,
      selectedInterfaces: [],
      selectedInterface: null,
      selectedApp: this.a,
      on: false,
    };
  },
  computed: {
    ...mapState({
      organisationDashboard: (state) => state.orgs.organisationDashboard,
      apps: (state) => state.apps.apps,
    }),
    ...mapGetters(["getDashAllApps"]),
    interfacePlaceholder() {
      return this.selectedApp && this.getInterfacesForApp.length === 0
        ? "No interfaces available"
        : "Select interface";
    },
    getInterfacesForApp() {
      const app = this.orgData.apps.filter((org) => {
        return org.id === this.selectedApp;
      });
      return app[0]?.interfaces || [];
    },
  },
  async created() {
    await this.$store.dispatch("getApps", {
      c: this.$route.query.c,
      q: "",
    });

    this.selectedInterface = this.getInterfacesForApp[0]?.hash;
    this.chooseApp(this.apps[0]?.appID);
  },
  methods: {
    chooseApp(appID) {
      this.selectedApp = appID;
      this.$emit('selectApp', appID);
      if (this.getInterfacesForApp[0]) {
        this.selectedInterface = this.getInterfacesForApp[0].id;
      } else {
        this.selectedInterface = null;
      }
    },
    chooseInterface(interfaceID) {
      this.interfaceID = interfaceID;
    },
  },
};
</script>

<style lang="scss">
::v-deep input.vs_search {
  min-width: 180px !important;
}

.app-interfaces-events-chart-wrapper {
  display: flex;
  flex-wrap: wrap;
  &__app-select {
    width: 180px;
  }

  &__interface-select {
    width: 180px;
  }

  &__header {
    display: flex;
    width: 100%;
    max-width: 940px;
    margin-bottom: 16px;
    align-items: center;


    @media (max-width: 768px) {
      flex-wrap: wrap;
    }
  }

  &__switch {
    max-width: 320px;
  }

  &__title {
    font-size: var(--font-h2-size);
    font-weight: var(--font-semi-bold);
    @media (max-width: 768px) {
      margin-bottom: 16px;
    }
  }

  &__charts {
    display: flex;
    flex-wrap: wrap;
  }
  &__chart {
    width: 454px;
    height: fit-content;
    background: white;

    margin-bottom: 24px;
    border: 1px solid var(--apio-shade-4);
    border-radius: 4px;
    padding: 16px;

    &--expanded {
      max-width: 940px;
      width: 100%;
      margin-right: 0 !important;
    }

    @media (min-width: 768px) {
      margin-right: 32px;
    }
  }
}
</style>